import { Toaster } from "@/components/ui/sonner";
import { useLenis } from "@/hooks/useLenis";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Manifesto } from "@/components/site/Manifesto";
import { NameMeaning } from "@/components/site/NameMeaning";
import { Timeline } from "@/components/site/Timeline";
import { FamilyTree } from "@/components/site/FamilyTree";
import { Gallery } from "@/components/site/Gallery";
import { Tartan } from "@/components/site/Tartan";
import { Distribution } from "@/components/site/Distribution";
import { Ancestry } from "@/components/site/Ancestry";
import { Join } from "@/components/site/Join";
import { Members } from "@/components/site/Members";
import { Footer } from "@/components/site/Footer";
import { AutoDetectNotice } from "@/components/site/AutoDetectNotice";

export default function Home() {
  useLenis();

  return (
    <div className="relative min-h-screen bg-clan-bg text-clan-ink">
      <div className="grain-overlay" aria-hidden="true" />
      <Header />
      <main>
        <Hero />
        <Manifesto />
        <NameMeaning />
        <Timeline />
        <FamilyTree />
        <Gallery />
        <Tartan />
        <Distribution />
        <Ancestry />
        <Join />
        <Members />
      </main>
      <Footer />
      <AutoDetectNotice />
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}
